import { render, staticRenderFns } from "./AddCommande.vue?vue&type=template&id=e8a77af0&"
import script from "./AddCommande.vue?vue&type=script&lang=js&"
export * from "./AddCommande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports